<template>
  <q-item v-bind="$attrs" @click="viewClientProfile">
    <q-item-section>
      <q-item-label v-if="data.numNewPosts === 0">
        <strong>{{ data.client.name }}</strong>
        added their {{ data.platform }} account but it contains no posts.
      </q-item-label>
      <q-item-label v-else>
        <strong>{{ data.client.name }}</strong>
        imported {{ data.numNewPosts }} {{ data.platform }} post(s).
      </q-item-label>
      <q-item-label caption>
        <slot></slot>
      </q-item-label>
    </q-item-section>
  </q-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

interface PostImportComplete {
  client: {
    id: number,
    name: string,
  },
  platform: string,
  numNewPosts: number,
}

export default defineComponent({
  props: {
    data: {
      type: Object as () => PostImportComplete,
      required: true,
    },
  },
  methods: {
    viewClientProfile() {
      this.$router.push(`/clients/${this.data.client.id}`);
    },
  },
});
</script>
